import { users, products, store, decentralized } from "@/services";

const state = {
  token: null,
  authUser: {},
  discount: 0,
  permissionUser: [],
};

const getters = {
  AUTHENTICATED(state) {
    return state.token != null ? true : false;
  },

  AUTH_USER(state) {
    return state.authUser;
  },

  DISCOUNT_CLIENT(state) {
    return state.discount;
  },

  GET_PERMISSION_USER(state) {
    return state.permissionUser;
  },
};

const mutations = {
  /**
   * [SET_TOKEN description]
   * Asignar token solo en instancia axios
   * @param {[type]} state   [description]
   * @param {[type]} payload [description]
   */
  SET_TOKEN(payload) {
    users.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
    products.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
    store.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
    decentralized.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${payload}`;
  },

  /**
   * [description]
   * @param  {[type]} state   [description]
   * @param  {string} payload [description]
   * @return {[type]}         [description]
   */
  ADD_TOKEN: (state, payload) => {
    localStorage.setItem("token", payload);
    state.token = payload;

    users.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
    products.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
    store.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
    decentralized.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${payload}`;
  },

  ADD_PERMISSION(state, payload) {
    state.permissionUser = payload;
  },

  ADD_STORE_ID(state, payload) {
    localStorage.setItem("store", payload);
  },

  ADD_DISCOUNT_CLIENT: (state, payload) => {
    state.discount = payload;
  },

  CLEAR_TOKEN: (state) => {
    localStorage.clear();
    state.token = null;
    delete users.defaults.headers.common["Authorization"];
    delete products.defaults.headers.common["Authorization"];
    delete store.defaults.headers.common["Authorization"];
    delete decentralized.defaults.headers.common["Authorization"];
  },

  AUTH_USER: (state, payload) => {
    state.authUser = payload;
  },
};

const actions = {
  async LOGIN({ commit }, payload) {
    try {
      const response = await users.post("api/auth/login/buyers", payload);
      commit("ADD_TOKEN", response.data.data.access_token.token);
      commit("ADD_STORE_ID", response.data.data.user.store_id);
      commit("ADD_PERMISSION", response.data.data.user.permissions_b2b_main);
      // commit("ADD_DISCOUNT_CLIENT", response.data.discount);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async TRY_AUTO_LOGIN({ commit, dispatch }) {
    try {
      const token = localStorage.getItem("token");
      if (token === null) {
        return;
      } else {
        commit("ADD_TOKEN", token);
        dispatch("GET_LOGIN_USER");
        return true;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_LOGIN_USER({ commit }) {
    try {
      const store_id = localStorage.getItem("store");

      const response = await users.get(
        `api/buyers/auth/getuser?store_id=${store_id}`
      );
      const permissions = JSON.parse(response.data.data.permissions_b2b_main);
      commit("ADD_PERMISSION", permissions);
      commit("AUTH_USER", { ...response.data.data.buyer, status_invoice: response.data.data.b2b_invoice });
      // commit("ADD_DISCOUNT_CLIENT", response.data.discount);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async LOGOUT({ commit }) {
    try {
      // const response = await Api.get("/auth/logout");
      commit("CLEAR_TOKEN");
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SIGNUP(_, payload) {
    try {
      const response = await users.post("api/buyers", payload);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_STATES(_, payload) {
    try {
      const response = await decentralized.post(`api/country/state`, payload);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// exportar propiedades
export const auth = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
